export enum OrderStatuses {
  allocated = 'ALLOCATED',
  authorized = 'AUTHORIZED',
  cancelled = 'CANCELLED',
  complete = 'COMPLETE',
  confirmed = 'CONFIRMED',
  despatched = 'DESPATCHED',
  draft = 'DRAFT',
  emailed = 'EMAILED',
  exStock = 'EX STOCK',
  imported = 'IMPORTED',
  inProduction = 'IN PRODUCTION',
  invoiced = 'INVOICED',
  pending = 'PENDING',
  picked = 'PICKED',
  printed = 'PRINTED',
  rejected = 'REJECTED',
  toCut = 'TO CUT',
  toPack = 'TO PACK',
}
